import './modalreceipt.scss';

import Logo from '../../../../assets/images/logos/logo-white-small.png';
import Close from '../../../../assets/images/icons/close-square.png';

import { FunctionComponent } from "react";
import { useAppDispatch, useAppSelector } from '../../../../features';
import { getReceiptStatus, ReceiptCategory, setReceiptData, setReceiptStatus } from '../../../../store/ReceiptSlice';
import { setModalSignInUp } from '../../../../store/AppSlice';
import { modalTypeEnum } from '../../../../types/modal';
import { ChargeReceipt } from './charge';
import { WithdrawalReceipt } from './withdrawal';

export const ModalReceipt: FunctionComponent = () => {

    const dispatch = useAppDispatch()

    const receiptStatus : ReceiptCategory   = useAppSelector(getReceiptStatus); 

    const handleClose = () => {
        dispatch(setModalSignInUp(modalTypeEnum.none));
        dispatch(setReceiptStatus(ReceiptCategory.none));
        dispatch(setReceiptData(null));
    }

    let Component: React.ElementType | null = null; // Default to null
    
    if (receiptStatus === ReceiptCategory.charge) Component = ChargeReceipt
    if (receiptStatus === ReceiptCategory.withdrawal) Component = WithdrawalReceipt

    return (
        <div className="modal-receipt">
            <div className="modal-header">
                <span></span>
                <div className="logo">
                    <img src={Logo} alt="" />
                </div>
                <img className="white" src={Close} alt="" onClick={handleClose}/>
            </div>
            {Component ? <Component /> : <p>Tipo de recibo inválido</p>}
            <div className="modal-footer">
                Este é um recibo gerado eletronicamente.<br/>
                Para quaisquer dúvidas, entre em contato com support@trkbit.co
            </div>
        </div>
    )
}